import script from "./ModalPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPanel.vue?vue&type=script&setup=true&lang=js"

import "./ModalPanel.vue?vue&type=style&index=0&id=578d7828&lang=css"

const __exports__ = script;

export default __exports__